import styled from 'styled-components';
import { X } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { Card } from '@/components/common/Card';
import { theme } from '@/styles/theme';
import { staggerContainer, fadeInUp } from '@/styles/animations';
import mascotWonderingImage from '@/assets/mascot_wondering.png';

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing.xxxl};
  align-items: center;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.xl};
  }
`;

const TextContent = styled.div``;

const Title = styled.h2`
  margin-bottom: ${theme.spacing.xxl};
  color: ${theme.colors.text.black};
`;

const PainPoints = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

const PainPointCard = styled(Card)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  background: ${theme.colors.neutral[100]};
  border: 1px solid ${theme.colors.neutral[200]};
`;

const XIcon = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.status.danger};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PainPointText = styled.p`
  margin: 0;
  color: ${theme.colors.text.darkGray};
  font-weight: ${theme.fontWeights.medium};
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 400px;
    width: 100%;
    height: auto;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    order: -1;

    img {
      max-width: 250px;
    }
  }
`;

const painPoints = [
  'Traditional flashcards feel like homework',
  'Apps overwhelm you with too many features',
  'Hard to stay motivated and consistent',
];

export const ProblemSection = () => {
  return (
    <Section $padding="large" $background={theme.colors.secondary.warm}>
      <Container>
        <ContentWrapper>
          <TextContent>
            <Title>Tired of boring vocabulary drills?</Title>
            <PainPoints
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-100px' }}
            >
              {painPoints.map((point, index) => (
                <motion.div key={index} variants={fadeInUp}>
                  <PainPointCard>
                    <XIcon>
                      <X size={24} weight="bold" />
                    </XIcon>
                    <PainPointText>{point}</PainPointText>
                  </PainPointCard>
                </motion.div>
              ))}
            </PainPoints>
          </TextContent>
          <ImageWrapper>
            <img src={mascotWonderingImage} alt="Lexifox mascot wondering" />
          </ImageWrapper>
        </ContentWrapper>
      </Container>
    </Section>
  );
};
